var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { List } from 'immutable';
import { socket } from "../../socket";
import { Icon } from "../../UI";
import ShowIf from "../../App/ShowIf";

import SidePanel from "../../Layout/SidePanel";
import {
fetchSearches,
submitNewSearch,
registerForUpdates,
updateSearch,
hideSemanticSearch } from "../actions/actions";


import SearchList from "./SearchList";

export class SemanticSearchSidePanel extends Component {
  constructor(props) {
    super(props);

    this.registeredForUpdates = false;
    this.onSearchUpdated = this.onSearchUpdated.bind(this);

    socket.on('semanticSearchUpdated', this.onSearchUpdated);
  }

  componentDidMount() {
    if (!this.registeredForUpdates) {
      this.props.registerForUpdates();
      this.registeredForUpdates = true;
    }
    this.props.fetchSearches();
  }

  componentWillUnmount() {
    socket.removeListener('semanticSearchUpdated', this.onSearchUpdated);
  }

  onSearchUpdated({ updatedSearch }) {
    this.props.updateSearch(updatedSearch);
  }

  render() {
    const searches = this.props.searches.toJS();
    const { open } = this.props;
    return /*#__PURE__*/(
      _jsx(SidePanel, { open: open, className: "metadata-sidepanel semantic-search" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "sidepanel-header" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "closeSidepanel close-modal",
        onClick: this.props.hideSemanticSearch }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "times" }))), /*#__PURE__*/


      _jsx("div", { className: "sidepanel-body" }, void 0, /*#__PURE__*/
      _jsx(ShowIf, { if: !!searches }, void 0, /*#__PURE__*/
      _jsx(SearchList, { searches: searches })))));




  }
}










export function mapStateToProps(state) {
  return {
    searches: state.semanticSearch.searches,
    search: state.semanticSearch.search,
    open: state.semanticSearch.showSemanticSearchPanel
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
  {
    fetchSearches,
    submitNewSearch,
    registerForUpdates,
    updateSearch,
    hideSemanticSearch
  },
  dispatch);

}

export default connect(mapStateToProps, mapDispatchToProps)(SemanticSearchSidePanel);